export * from './unwantedInfoList.component';
export * from './unwantedList.component';

